import { NgModule } from '@angular/core';
import { MainComponent } from './main.component';
import { DsLibMainMenuModule } from '@sixense/ds-lib-main-menu';
import { MainRoutingModule } from './main-routing.module';
import { DsLibCommonModule, DsLibLanguagePickerModule } from '@sixense/ds-lib-common';
import { DsUserAccountComponent } from './components/ds-user-account/ds-user-account.component';

@NgModule({
  declarations: [MainComponent, DsUserAccountComponent],
  imports: [DsLibCommonModule, MainRoutingModule, DsLibMainMenuModule, DsLibLanguagePickerModule],
})
export class MainModule {}
